import { Divider, Popover } from '@kc-console/common-ui';

import PopularServices from './PopularServices';
import RecentSearchKeywords from './RecentSearchKeywords';
import SearchGuide from './SearchGuide';
import SearchInput from './SearchInput';
import { useSearchPopover } from './SearchPopoverProvider';
import SearchResults from './SearchResults';

const SearchPopover = () => {
  const { popoverProps, inputValue } = useSearchPopover();

  return (
    <Popover
      {...popoverProps}
      onClick={e => e.stopPropagation()}
      transitionDuration={0}
      slotProps={{
        paper: {
          sx: {
            width: 400,
            backgroundColor: '#fff',
            boxShadow: '0px 3px 6px 0px #13161926',
            paddingBottom: '7px',
          },
        },
      }}
    >
      <>
        <SearchInput />
        <Divider margin={8} style={{ marginTop: 0 }} />
        {!inputValue && (
          <>
            <RecentSearchKeywords />
            <Divider margin={8} />
            <PopularServices />
          </>
        )}
        {inputValue && <SearchResults />}
        <Divider margin={8} />
        <SearchGuide />
      </>
    </Popover>
  );
};

export default SearchPopover;
